import {useEffect, useReducer} from 'react';

import deepEqual from 'fast-deep-equal/es6';

import {usePrevious} from './usePrevious';

export function usePersistedReducer(reducer, initialState, storageKey) {
  const PERSIST_VERSION = 1;

  function init() {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return initialState;

    try {
      const parsed = JSON.parse(raw);

      if (parsed._version !== PERSIST_VERSION) {
        return initialState;
      }

      return parsed.data;
    } catch {
      return initialState;
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState, init);
  const prevState = usePrevious(state);

  useEffect(() => {
    const stateEqual = deepEqual(prevState, state);
    if (!stateEqual) {
      localStorage.setItem(
        storageKey,
        JSON.stringify({
          _version: PERSIST_VERSION,
          data: state
        })
      );
    }
  }, [state]);

  return {state, dispatch};
}
